<div class="old-passwords-container">
  <div fxLayout="row" fxLayoutAlign="space-between center">

    <h2 *ngIf="typeList === 'NEXT'">Próximas Senhas</h2>
    <h2 *ngIf="typeList === 'OLD'">Historico de chamadas</h2>


    <button mat-icon-button [disabled]="loadingCallPassword" (click)="goBack()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!-- Password Column -->
    <ng-container matColumnDef="password">
      <th mat-header-cell *matHeaderCellDef> Senha </th>
      <td mat-cell *matCellDef="let element"> {{element.password}} </td>
    </ng-container>

    <!-- Patient Status Column -->
    <ng-container matColumnDef="patient_status">
      <th mat-header-cell *matHeaderCellDef> Tipo da Senha </th>
      <td mat-cell *matCellDef="let element"> {{element.patientStatus == 'P' ? 'PRIORIDADE' : 'NORMAL'}} </td>
    </ng-container>

    <!-- Patient Status Column -->
    <ng-container matColumnDef="environment">
      <th mat-header-cell *matHeaderCellDef> Local </th>
      <td mat-cell *matCellDef="let element"> {{element.environment}} </td>
    </ng-container>

    <!-- Patient Status Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="callPassword(element)" [disabled]="loadingCallPassword" *ngIf="typeList === 'OLD'"
          mat-icon-button matTooltip="Chamar senha">
          <mat-icon>refresh</mat-icon>
        </button>
        <button (click)="callPassword(element)" [disabled]="loadingCallPassword" *ngIf="typeList === 'NEXT'"
          mat-icon-button matTooltip="Chamar senha">
          <mat-icon>record_voice_over</mat-icon>
        </button>

        <button (click)="cancelPassword(element)" [disabled]="loadingCallPassword" *ngIf="typeList === 'NEXT'"
          mat-icon-button color="warn" matTooltip="Cancelar senha">
          <mat-icon>cancel</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [length]="totalElements" [pageIndex]="number" [pageSize]="sizePage" [pageSizeOptions]="[5]"
    (page)="updatePage($event)">
  </mat-paginator>

</div>